import React, { useState, useEffect, useRef } from 'react';
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { storage } from '../../helpers/storage';

const initialForm = {
    tienda: ""
}

const validationsFrom = (form) => {
    let errors = {};
    let regexName = /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s]+$/;
    //let regexEmail = /^(\w+[/./-]?){1,}@[a-z]+[/.]\w{2,}$/;
    let regexEmail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
    //let regexComments = /^.{1,255}$/;
    let regexDigitos = /^.{1,10}$/;
    let regexNumbers = /^([0-9])*$/;

    if(!form.tienda.trim()) {
        errors.tienda = "El Campo (Tienda) es requerido";
    } 
   
    return errors;
}

const Edit = ({visible, tienda, close, onComponentUpdate}) => {

    const toast = useRef(null);

    const [form, setForm] = useState(initialForm);
	const [errors, setErrors] = useState({});
	const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState(null);

    useEffect(() => {
        if(tienda != null) {
            const EditForm = {
                tienda: tienda.Tienda
            }

            setForm(EditForm);
            setErrors(validationsFrom(EditForm));
        } else {
            console.log('uno')
        }
    }, [tienda])
    
    const handleSubmit = (e) => {
		e.preventDefault();
  
        setErrors(validationsFrom(form));

        if (Object.keys(errors).length === 0) {

            const arrUser = {
                opcion: "M",
                IdTienda: tienda.IdTienda,
                Tienda: form.tienda
            };

            setLoading(true);

            helpHttp().post(`${BASE_API}Usuarios/Ejecutartiendas`, {
                body: arrUser,
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                },
                })
                .then((res) => {
                    if(res.SUCCESS === true) {
                        const updateData = {
                            IdTienda: tienda.IdTienda,
                            Tienda: arrUser.Tienda,
                            Activo: tienda.Activo
                        }
        
                        onComponentUpdate(updateData);
                        showToast('success', 'Tienda actualizada correctamente', '' );
                        close();
                    } else if(res.response === 'off') {
                        setResponse(res.message)
                        setLoading(false);
                    }
                    setLoading(false);
                });
        } else {
            showToast('warn', 'Aviso:', 'Favor de llenar los campos requeridos.');
            return;
        }
	};

    const handleChange = (e) => {
		const { name, value } = e.target;

		setForm({
			...form,
			[name]: value,
		});
	};

	const handleBlur = (e) => {
		handleChange(e);
		setErrors(validationsFrom(form));
	};

    const showToast = (severity, summary, detail ) => {
        toast.current.show({ 
            severity: severity, 
            summary: summary, 
            detail: detail, 
            life: 5000 
        });
    };

    return (
        <>
            <Toast ref={toast} />

            <Dialog header="Editar Usuario" id="modalEditarUsuario" breakpoints={{ '641px': '100vw' }} draggable={false} visible={ visible  } style={{ width: '30vw' }} modal onHide={ close }>
                <form onSubmit={handleSubmit} className="col-12">
                    <div className="div">
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12">
                                <label htmlFor="usuario">Tienda:</label>
                                <InputText id="tienda" name="tienda" type="text" value={form.tienda} onChange={handleChange} onBlur={handleBlur} className={errors.tienda && 'p-invalid'} autoFocus />
                                {errors.tienda && <small className="p-error">{errors.tienda}</small>}
                            </div>
                        </div>
                        <div className="p-dialog-footer text-right" style={{marginTop: '15px', paddingTop: '15px'}}>
                            <Button type='button' label="Cancelar" className="p-button-outlined p-button-secondary mr-2 mb-2" onClick={ close }/>
                            <Button type='submit' disabled={loading} icon={(loading ? 'pi pi-spin pi-spinner': '')} label="Guardar" className="p-button-raised p-button-danger mr-2 mb-2" />
                        </div>
                    </div>   
                </form>
            </Dialog>
        </>     
    );  
}

export default Edit;